import { MobileMenu as MobileMenuRoot } from '@bill-alps/ui';
import { CompanySwitcher } from '@/components/company-switcher';
import { MobileHeader } from './mobile-header';
import { Sidebar } from './sidebar';

interface MobileMenuProps {
  isAdmin: boolean;
  isSupport: boolean;
}

export function MobileMenu({ isAdmin, isSupport }: MobileMenuProps) {
  return (
    <MobileMenuRoot
      aria-label="Menu"
      renderTrigger={({ openMenu }) => (
        <MobileHeader isSupport={isSupport} onOpenMenu={openMenu} />
      )}
    >
      {({ closeMenu }) => (
        <div className="flex h-full flex-col overflow-hidden">
          <CompanySwitcher
            className="w-full shrink-0 border-b-2 border-border px-3 py-4"
            onSwitchSuccess={closeMenu}
          />
          <Sidebar
            isCollapsed={false}
            onToggle={closeMenu}
            onNavigate={closeMenu}
            isAdmin={isAdmin}
            className="!static !h-auto min-h-0 !w-full flex-1 !border-r-0"
          />
        </div>
      )}
    </MobileMenuRoot>
  );
}
